import React from 'react';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { Group, IconToggle, NumberField, Section } from '../controls';
import styles from './sections.module.css';

// The resize handles' own lower limit.
const MIN_SIZE = 10;

/** Width and height, with an aspect lock between them. */
const SizeSection = ({ values, change, lockAspect, setLockAspect }) => (
    <Section id="size" icon={<OpenInFullIcon />} title="Size">
        <div className={styles.sizeGrid}>
            <Group label="Width">
                <NumberField title="Width" unit="px" min={MIN_SIZE} value={values.width} onChange={(width) => change({ width })} />
            </Group>
            <IconToggle
                on={lockAspect}
                title={lockAspect ? 'Unlock aspect ratio' : 'Lock aspect ratio'}
                onClick={() => setLockAspect(!lockAspect)}
            >
                {lockAspect ? <LinkIcon /> : <LinkOffIcon />}
            </IconToggle>
            <Group label="Height">
                <NumberField title="Height" unit="px" min={MIN_SIZE} value={values.height} onChange={(height) => change({ height })} />
            </Group>
        </div>
    </Section>
);

export default SizeSection;
